<template>
  <div>
    <!-- Tombol Toggle Sidebar (Hanya Muncul di Mobile) -->
    <button class="toggle-sidebar-btn d-md-none" @click="toggleSidebar">
      <i :class="isSidebarOpen ? 'bi bi-x' : 'bi bi-list'"></i>
    </button>

    <!-- Sidebar -->
    <aside id="sidebar" :class="['sidebar', { 'sidebar-open': isSidebarOpen }]">
      <br>
      <ul class="sidebar-nav" id="sidebar-nav">
        <br>
        <li class="nav-item">
          <label for="company" class="block text-sm font-medium text-gray-700 mb-1">Pilih Perusahaan</label>
            <select 
              v-model="selectedCompany" 
              name="company" 
              id="company" 
              class="form-select block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              @change="changeCompany"
            >
              <option disabled value="">-- Pilih Perusahaan --</option>
              <option 
                v-for="company in companies" 
                :key="company.id" 
                :value="company.id"
              >
                {{ company.company_name }}
              </option>
            </select>
        </li>
        <li class="nav-item">
          <router-link to="/" class="logo d-flex align-items-center nav-link collapsed">
            <i class="bi bi-grid"></i>
            <span style="font-size: 20px;">Dashboard</span>
          </router-link>
        </li>
        <li class="nav-item">
          <div @click="toggleDropdown" class="logo d-flex align-items-center nav-link collapsed">
            <div class="d-flex align-items-center justify-content-between">
              <i class="bi bi-list"></i>
              <span style="font-size: 15px;">Data Konten</span>
              <i class="bi ms-2" :class="isDropdownOpen ? 'bi-caret-up' : 'bi-caret-down'"></i>
            </div>
          </div>

          <transition name="dropdown">
            <ul v-show="isDropdownOpen" class="dropdown-list">
              <li><router-link to="/data-operasional" class="dropdown-item"><i class="bi bi-gear"></i> Konten Operasional</router-link></li>
              <li v-if="selectedCompany === 1"><router-link to="/data-milestones" class="dropdown-item"><i class="bi bi-flag"></i> Konten Milestone</router-link></li>
              <li><router-link to="/data-client" class="dropdown-item"><i class="bi bi-people"></i> Konten Client</router-link></li>
              <li><router-link to="/data-service" class="dropdown-item"><i class="bi bi-tools"></i> Konten Services</router-link></li>
              <li><router-link to="/data-advantage" class="dropdown-item"><i class="bi bi-lightbulb"></i> Konten Kelebihan</router-link></li>
              <li v-if="selectedCompany === 1"><router-link to="/data-area" class="dropdown-item"><i class="bi bi-map"></i> Konten Area</router-link></li>
              <li><router-link to="/data-faq" class="dropdown-item"><i class="bi bi-question-circle"></i> Konten Q&A</router-link></li>
              <li><router-link to="/data-technology" class="dropdown-item"><i class="bi bi-gear-wide-connected"></i> Konten Teknologi</router-link></li>
              <li><router-link to="/data-berita" class="dropdown-item"><i class="bi bi-newspaper"></i> Konten Berita</router-link></li>
              <li><router-link to="/data-sdgs" class="dropdown-item"><i class="bi bi-compass"></i> Konten SDGS</router-link></li>
              <li><router-link to="/data-requirements" class="dropdown-item"><i class="bi bi-card-checklist"></i> Konten Persyaratan Kerja</router-link></li>
              <li><router-link to="/data-career" class="dropdown-item"><i class="bi bi-briefcase"></i> Konten Karir</router-link></li>
              <li v-if="selectedCompany !== 1"><router-link to="/data-gudang" class="dropdown-item"><i class="bi bi-box-seam"></i> Konten Gudang</router-link></li>
              <!-- <li><router-link to="/data-answer" class="dropdown-item"><i class="bi bi-chat-dots"></i> Konten Jawaban</router-link></li>
              <li><router-link to="/data-question" class="dropdown-item"><i class="bi bi-question-circle"></i> Konten Pertanyaan</router-link></li> -->
              <!-- test -->
            </ul>
          </transition>
        </li>
        <li v-if="selectedCompany === 1" class="nav-item">
          <router-link to="/data-vehicles" class="logo d-flex align-items-center nav-link collapsed">
            <i class="bi bi-truck"></i>
            <span style="font-size: 15px;">Data Kendaraan FLI</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/data-applicants" class="logo d-flex align-items-center nav-link collapsed">
            <i class="bi bi-person-circle"></i>
            <span style="font-size: 15px;">Data Pelamar</span>
          </router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link to="/data-rate" class="logo d-flex align-items-center nav-link collapsed">
            <i class="bi bi-chat-left-text"></i>
            <span style="font-size: 15px;">Data Ulasan</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/data-complaint" class="logo d-flex align-items-center nav-link collapsed">
            <i class="bi bi-exclamation-circle"></i>
            <span style="font-size: 15px;">Data Complaint</span>
          </router-link>
        </li> -->
      </ul>
    </aside>
  </div>
</template>

<script>
import companyController from './controllers/companyController/controller';
import { EventBus } from '../eventBus';
export default {
  name: 'SidebarComponent',
  data() {
    return {
      selectedCompany: 1,
      companies: [],
      isSidebarOpen: false,
      isDropdownOpen: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    async fetchCompany(){
      try {
        const data = await companyController.fetchCompany();
        this.companies = data;
      } catch (error) {
        console.error('Error fetching companies:', error);
        throw error;
      }
    },
    changeCompany() {
      localStorage.setItem("company", JSON.stringify(this.selectedCompany));
      // kirim event ke komponen lain
      EventBus.$emit("companyChanged", this.selectedCompany);
    }
  },
  mounted() {
    this.fetchCompany();
    this.changeCompany();
    localStorage.setItem("company", JSON.stringify(this.selectedCompany));
  }
};

</script>

<style scoped>
/* Atur posisi sidebar di atas header */
.sidebar {
  position: fixed;
  top: 0;
  left: -250px; /* Sidebar tersembunyi */
  height: 100%;
  width: 250px;
  background-color: #f8f9fa;
  transition: left 0.3s ease;
  z-index: 999;
}

.sidebar-open {
  left: 0;
}

/* Tombol toggle sidebar */
.toggle-sidebar-btn {
  position: fixed;
  top: 10px;
  left: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  z-index: 1000;
}

/* Atur ikon pada tombol */
.toggle-sidebar-btn i {
  font-size: 1.5rem;
}

/* Sidebar hanya aktif di tampilan mobile */
@media (min-width: 768px) {
  .toggle-sidebar-btn {
    display: none; /* Sembunyikan tombol toggle di desktop */
  }
  .sidebar {
    left: 0; /* Sidebar selalu terlihat di desktop */
  }
}

ul.list-unstyled {
  padding-left: 1rem;
}

ul.list-unstyled .dropdown-item {
  padding: 6px 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

ul.list-unstyled .dropdown-item i {
  margin-right: 8px;
}
/* Animasi smooth dropdown */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}
.dropdown-enter,
.dropdown-leave-to {
  max-height: 0;
  opacity: 0;
}

/* Saat dropdown terbuka */
.dropdown-list {
  list-style: none;
  padding-left: 1.5rem;
  margin: 0;
}

/* Styling item dropdown */
.dropdown-item {
  padding: 8px 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
  text-decoration: none;
  transition: background 0.2s;
}

.dropdown-item i {
  margin-right: 8px;
}

/* Hover efek */
.dropdown-item:hover {
  background-color: #e9ecef;
  border-radius: 5px;
}

</style>

